var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound52AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M41.78 26.296C40.71 31.825 35.843 36 30 36s-10.71-4.175-11.78-9.704c-.118-.607.386-1.296 1.28-1.296h21c.894 0 1.398.689 1.28 1.296Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M13 24.5c0 4.341 1.765 8.527 4.942 11.63C21.122 39.236 25.458 41 30 41s8.878-1.764 12.059-4.87C45.235 33.027 47 28.841 47 24.5a4.5 4.5 0 1 1 9 0c0 6.798-2.766 13.295-7.653 18.068C43.464 47.338 36.862 50 30 50c-6.862 0-13.463-2.661-18.347-7.432C6.766 37.795 4 31.298 4 24.5a4.5 4.5 0 1 1 9 0Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M56 24a26 26 0 1 1-52 0"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M25 10h10l.752 8.274A2.5 2.5 0 0 1 33.262 21h-6.524a2.5 2.5 0 0 1-2.49-2.726L25 10Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m24 12 .223-.445A2.813 2.813 0 0 1 26.738 10h6.524c1.065 0 2.039.602 2.515 1.555L36 12"
})));
SvgRound52AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound52AError);
export default ForwardRef;